import loadable from '@loadable/component';

export const game_buy_book_payment = loadable(() => import("./GameBuyBookPaymentPage"));
export const game_buy_book_bonus = loadable(() => import("./GameBuyBookBonusPage"));
export const game_buy_book_owner = loadable(() => import("./GameBuyBookOwnerPage"));
export const game_buy_book_external_payment = loadable(() => import("./GameBuyBookExternalPaymentPage"));
